import Axios from "axios";

export default {
    getBundles(itemId, params) {
        return Axios.get(
            `${process.env.BARRAMUNDI}inventory/bundles${
                itemId ? "/" + itemId : ""
            }`,
            { params }
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    getBundlesCount(itemId) {
        return Axios.get(
            `${process.env.BARRAMUNDI}inventory/bundle/${itemId}/count`
        ).then(res => {
            if (res.data && res.data.response && res.data.response.resource) {
                return res.data.response.resource;
            }
            return 0;
        });
    },
    async addItemToBundle({ itemId, bundleId, params }) {
        let res = await Axios.post(
            `${process.env.BARRAMUNDI}inventory/bundle/${itemId}/${bundleId}`,
            params
        );
        if (res.data && res.data.response) {
            return res.data.response;
        } else {
            return null;
        }
    },
    /**
     * @method getTotalPrice
     * @description this api is used to calculate the totalFee
     * @param {String} itemId
     * @param {Object} params {"item_id":"a585b00c-afac-44","module":"bundle"}
     * @example {"quantity": 3,"unit_price":10,"is_custom_price":1,"fees_total": 25,"fees": ["f2bbc560-1b5d-48"]}
     * @returns
     */
    getTotalPrice(itemId, params) {
        return Axios.get(
            `${process.env.BARRAMUNDI}inventory/bundle/${itemId}/total-price-fee`,
            {
                params
            }
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return 0;
        });
    },
    /**
     * @method checkNegativeBundle
     * @description this api is used to calculate the totalFee
     * @param {String} itemId
     * @param {Object} params {"item_id":"a585b00c-afac-44","module":"bundle"}
     * @example {"quantity": 3,"unit_price":10,"is_custom_price":1,"fees_total": 25,"fees": ["f2bbc560-1b5d-48"]}
     * @returns
     */
    checkNegativeBundle(itemId, params) {
        return Axios.get(
            `${process.env.BARRAMUNDI}inventory/bundle/${itemId}/check-negative-bundle`,
            {
                params
            }
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return 0;
        });
    },
    async updateItemBundle({ itemId, bundleId, params }) {
        let res = await Axios.put(
            `${process.env.BARRAMUNDI}inventory/bundle/${itemId}/${bundleId}`,
            params
        );
        if (res.data && res.data.response) {
            return res.data.response;
        } else {
            return null;
        }
    },
    deleteFromBundle(itemId, bundleId) {
        return Axios.delete(
            `${process.env.BARRAMUNDI}inventory/bundle/${itemId}/${bundleId}`
        ).then(response => response.data);
    }
};
